import React,{useEffect, useState} from 'react';
import {fetchData} from '../Utils/FetchData';
import MovieCard from '../components/MovieCard/MovieCard';
import { motion } from 'framer-motion'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'
import SimilarCards from '../components/Similar/SimilarCards';
import TvSimilarVideos from '../components/Similar/TvSimilarVideos';
import Loading from '../Utils/Loading';
import {settings, settings2} from '../Utils/slider'
import {useGlobalContext} from '../Utils/ContextApi'


function Home(props) {
  const [trending, setTrending] = useState([])
  const [trendingSeries, setTrendingSeries] = useState([])
  const [upComing, setUpComing] = useState([])
  const {isLoading, setIsLoading} = useGlobalContext()
  
  useEffect(()=>{
    const getTrending = async () => {
      try{
        setIsLoading(true)
      const trendData = await fetchData(`https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}&page=1`)
      setTrending(trendData)
      
      const series = await fetchData(`https://api.themoviedb.org/3/discover/tv?api_key=${process.env.REACT_APP_API_KEY}&page=1`)
      setTrendingSeries(series)
      
      const comingUp = await fetchData(`https://api.themoviedb.org/3/movie/upcoming?api_key=${process.env.REACT_APP_API_KEY}`)
      setUpComing(comingUp)

      setIsLoading(false)
    } catch(error){
      console.log(error)
    }
  }
    getTrending()

  }, [])

  if(isLoading){
    return <Loading />
  }else{
    return(
  <motion.div className='trend'
    initial={{opacity:0.3}}
    animate={{opacity:1}}
    exit={{opacity:0, transition: {duration:  0.1}}}
    style={{padding:"10px 25px"}}>

    <h3>Popular Movies</h3>
        <Slider {...settings}>
        {trending.map((movie, index)=>{
                return(
                    <SimilarCards {...movie} keys={movie.id} />
                )
            })}
        
        </Slider>
        <h3>Trending Series</h3>
        <Slider {...settings2}>
        {trendingSeries.map((series, index)=>{
                return(
                    <TvSimilarVideos {...series} keys={series.id} />
                )
            })} 
        </Slider>
        <h3>Movies in Theatres</h3>
        <Slider {...settings}>
        {upComing.map((latest, index)=>{
                return(
                    <SimilarCards {...latest} keys={latest.id} />
                )
            })} 
        </Slider>
    </motion.div>
  )}

}

export default Home